module.exports = __webpack_public_path__ + "img/emoji-fire-240x240.6ac9b148.png";